module.exports = __webpack_public_path__ + "img/home-content-0.729c2c0b.png";